import React from 'react';
import Browser from "../../assets/images/safari-browser-top.png";
import Image from 'react-bootstrap/Image';
import '../../assets/scss/browser-top.scss';

interface IProps {
    fakeUrl: string;
}

function BrowserTop(props: IProps) {
    return (
        <div className="browser-container">
            <span className="browser-url" >{props.fakeUrl}</span>
            <Image className="w-100" src={Browser} />
        </div>
    );
}

export default BrowserTop;